// @module DC.PDPSpecificationTab.PDPSpecificationExt
define('DC.PDPSpecificationTab.PDPSpecificationExt.View'
,	[
	'dc_pdpspecificationtab_pdpspecificationext.tpl'
	
	,	'DC.PDPSpecificationTab.PDPSpecificationExt.SS2Model'
	
	,	'Backbone'
    ]
, function (
	dc_pdpspecificationtab_pdpspecificationext_tpl
	
	,	PDPSpecificationExtSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class DC.PDPSpecificationTab.PDPSpecificationExt.View @extends Backbone.View
	return Backbone.View.extend({

		template: dc_pdpspecificationtab_pdpspecificationext_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new PDPSpecificationExtModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return DC.PDPSpecificationTab.PDPSpecificationExt.View.Context
	,	getContext: function getContext()
		{
			//@class DC.PDPSpecificationTab.PDPSpecificationExt.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
